import React, {useMemo} from 'react';
import {PRODUCT_ITEM, PRODUCT_ITEM_FORM} from "v4/data/apiRoutes";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import FullPageFormLayout from "v4/layouts/FullPageFormLayout/FullPageFormLayout";

export default function ProductsEdit({articleId}) {
    const fetchFormParameters = useMemo(() => ({
        id: articleId
    }), [articleId]);

    return (
        <FullPageFormLayout title="edit_product">
            <FormEntityLayout formRouteName={PRODUCT_ITEM_FORM}
                              submitRouteName={PRODUCT_ITEM}
                              fetchFormParameters={fetchFormParameters}
                              whenSubmitted={whenSubmitted}/>
        </FullPageFormLayout>
    )
}

function whenSubmitted(history, {id}) {
    history.push(
        history.location.pathname.replace(`/${id}/edit`, ''), {hasToRefresh: true});
}
